import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import {
  AuthenticationResult,
  InteractionStatus,
  InteractionType,
  PopupRequest,
  RedirectRequest,
} from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { UserManagementService } from './Service/user-management.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Admin Panel';
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  // msalInstance = new Msal.UserAgentApplication(msalConfig);
  userdetail;
  name;
  UserId;
  UserRole;

  isPreset = false;

  urlMapping = {
    1: '',
    2: 'document',
    3: 'market-rate-historical-data',
    4: 'Govt-schemes-list',
    5: 'FertilizerList',
    6: 'in-app-review',
    7: 'track-your-harvest',
    8: 'ask-an-expert',
    9: 'add-blog-list',
    10: 'survey-data',
    11: 'news-historical-data',
    12: 'product-list',
    13: 'access-control',
    14: 'setting',
    15: 'transaction-list',
    16: 'discussionboard',
    17: 'banner-Management',
    18: 'video-library'
  };

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private router: Router,
    public _userService: UserManagementService,
    private msalBroadcastService: MsalBroadcastService
  ) {}

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
    this.getToken();
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        setTimeout(() => {
          this.setLoginDisplay();
        });
        // this.setLoginDisplay();
      });
  }
  response;
  roleId;

  checkAuthentication() {
    this.getgropId.forEach((resp: any) => {
      if (
        resp === 'fc879d34-5db0-46d3-ace2-532e132f2d96' ||
        resp === '50eaa793-1c83-4078-ab3d-7bf1ae431853'
      ) {
      } else {
      }
    });
  }

  setLoginDisplay() {
    // this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    this.userdetail = this.authService.instance.getAllAccounts();
    if (this.userdetail && this.userdetail.length > 0) {
      localStorage.setItem('UserName', this.userdetail[0].name);
      localStorage.setItem('UserEmail', this.userdetail[0].username);

      var role = '';

      this.getgropId = this.userdetail[0].idTokenClaims.groups;
      localStorage.setItem('GroupID', role);

      if (
        this.getgropId.indexOf('fc879d34-5db0-46d3-ace2-532e132f2d96') !== -1
      ) {
        role = 'fc879d34-5db0-46d3-ace2-532e132f2d96';
      }
      if (
        this.getgropId.indexOf('50eaa793-1c83-4078-ab3d-7bf1ae431853') !== -1
      ) {
        role = '50eaa793-1c83-4078-ab3d-7bf1ae431853';
      }
      const postdata = new FormData();
      postdata.append('Name', this.userdetail[0].name);
      postdata.append('RoleId', role);
      postdata.append('EmailId', this.userdetail[0].username);
      postdata.append('IsLoginRole', 'true');
      this._userService.getUserdetails(postdata).subscribe((data) => {
        this.response = data;
        this.UserRole = this.response.result.data.roleName;
        if (this.UserRole === 'SUPERADMIN') {
          localStorage.setItem('isAdmin', 'true');
        } else {
          localStorage.setItem('isAdmin', 'false');
        }
        this.UserId = this.response.result.data.userId;
        localStorage.setItem('UserRole', this.UserRole);
        localStorage.setItem('UserId', this.UserId);
        // localStorage.getItem("UserRole");
        this.GetTotalCount();
      });
      this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
      this.name = this.userdetail[0].name;

      localStorage.setItem(
        'azureauthtoken',
        this.userdetail[0].homeAccountId +
          '-' +
          this.userdetail[0].environment.toLowerCase() +
          '-idtoken-' +
          this.userdetail[0].idTokenClaims.aud +
          '-' +
          this.userdetail[0].tenantId +
          '-'
      );
      var tocken = sessionStorage.getItem('user.read');
    }
    // this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }
  username;
  getgropId: any[];
  login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService
          .loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
            this.userdetail = this.authService.instance.getAllAccounts();

            this.gotoPage();
          });
      } else {
        this.authService
          .loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
            this.userdetail = this.authService.instance.getAllAccounts();
            this.gotoPage();
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({
          ...this.msalGuardConfig.authRequest,
        } as RedirectRequest);
        this.gotoPage();
      } else {
        this.authService.loginRedirect();
        this.gotoPage();
      }
    }
  }

  getToken() {
    // if the user is already logged in you can acquire a token
    if (this.authService.instance.getAllAccounts()) {
      var tokenRequest = {
        scopes: ['user.read'],
      };
      this.authService.instance
        .acquireTokenSilent(tokenRequest)
        .then((response) => {
          // get access token from response
          // response.accessToken
        })
        .catch((err) => {
          // could also check if err instance of InteractionRequiredAuthError if you can import the class.
          if (err.name === 'InteractionRequiredAuthError') {
            return this.authService.instance
              .acquireTokenPopup(tokenRequest)
              .then((response) => {
                // get access token from response
                // response.accessToken
              })
              .catch((err) => {
                // handle error
              });
          }
        });
    } else {
      // user is not logged in, you will need to log them in to acquire a token
    }
  }

  logout() {
    this.authService.logout();
  }

  // unsubscribe to events when component is destroyed
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  gotoPage() {
    this.router.navigateByUrl('/');
  }

  //access control function and unauthorized access
  accessData;
  menuAccessData;
  menusObj;

  GetTotalCount() {
    var postdata = {
      userId: this.UserId,
    };

    this._userService.getMenuList(postdata).subscribe((data) => {
      this.accessData = data;
      this.menuAccessData = this.accessData.result.data.menuAccess;

      const authMap = {};
      if (this.menuAccessData) {
        this.menusObj = {};
        for (var i = 0; i < this.menuAccessData.length; i++) {
          authMap[
            this.urlMapping[this.menuAccessData[i].menuId].toLowerCase()
          ] = this.menuAccessData[i].isAccessible;
          this.menusObj[this.menuAccessData[i].menuId] =
            this.menuAccessData[i].isAccessible;
        }
        localStorage.setItem('authMap', JSON.stringify(authMap));
        // if(this.router.url.replace('/','').toLowerCase()==='unauthorized-page'){

        // }
        if (!authMap[this.router.url.replace('/', '').toLowerCase()]) {
          for (var i = 0; i < this.menuAccessData.length; i++) {
            if (this.menuAccessData[i].isAccessible) {
              this.router.navigate([
                this.urlMapping[this.menuAccessData[i].menuId],
              ]);
              return;
            }
          }
        } else {
          this.router.navigate([
            this.router.url.replace('/', '').toLowerCase() ===
            'unauthorized-page'
              ? ''
              : this.router.url,
          ]);
        }
      } else {
        this.router.navigate([
          this.router.url.replace('/', '').toLowerCase() === 'unauthorized-page'
            ? ''
            : this.router.url,
        ]);
      }
    });
  }
}
